import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import NotificationsContext from 'providers/Notifications/Notifications.context';
import { NOTIFICATION_GROUP, NotificationGroup } from 'models/Notification';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';
import { Button } from 'ncoded-component-library';

import './NotificationGroupSelect.styles.scss';

type NotificationGroupSelectProps = {
  className?: string;
};

const NotificationGroupSelect: React.FC<NotificationGroupSelectProps> = (
  props,
) => {
  const { className } = props;

  const { notificationGroup, setNotificationGroup } =
    useContext(NotificationsContext);

  const classes = classNames('notification-group-select', className);

  const { t } = useTranslation();

  const options = useCreateSelectOptions()(Object.values(NOTIFICATION_GROUP));

  const groupOptions = useMemo(
    () => [...options, { value: undefined, label: t('all') }],
    [options, t],
  );

  return (
    <div className={classes}>
      {groupOptions.map(({ value, label }) => (
        <Button
          key={label}
          variant="outline"
          className={classNames({ selected: notificationGroup === value })}
          onClick={() => setNotificationGroup(value as NotificationGroup)}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};

export default NotificationGroupSelect;
